import styled from 'styled-components';

export const StyledForm = styled.form`
  &&& {
    max-width: 800px;
    margin: 12px auto;
    text-align: center;
  }
`;
